<template>
    <div>
        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="!isLoading && customer === null"
        >
            <div class="alert-body">
                Müşteri Bulunamadı
                <b-link
                    class="alert-link"
                    :to="{ name: 'customers' }"
                >
                    Müşteri
                </b-link>
                sayfasını görüntüle
            </div>
        </b-alert>
        
        <loading-card v-if="isLoading"></loading-card>
        
        <div v-else-if="customer !== null">
            <!-- Müşteri Bilgileri Card -->
            <b-card
                no-body
                class="invoice-preview-card invoice-preview"
            >
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">
                    <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <!-- Header: Left Content -->
                        <div>
                            <div class="logo-wrapper">
                                <h3 class="text-primary">
                                    {{ customer.name || 'Firma Adı Bulunamadı' }}
                                </h3>
                            </div>
                            <b-col
                                cols="12"
                                class="p-0"
                            >
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="pr-1">Domain :</td>
                                                <td>{{ customer.domain || 'Domain' }}</td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Admin :</td>
                                                <td>{{ customer.admin_user.name_surname || 'Adı Soyadı' }}</td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">E-Mail adresi :</td>
                                                <td>{{ customer.admin_user.email || 'Email' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                        </div>

                        <!-- Header: Right Content -->
                        <div class="mt-md-0 mt-2">
                            <h4 class="invoice-title">
                                Secret Key:
                                <span class="invoice-number">
                                    #{{ customer.secret_key || 'Bulunamadı' }}
                                </span>
                            </h4>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Kayıt Tarihi:</p>
                                <p class="invoice-date">
                                    {{ formatDate(customer.created_date) || 'Tarih Yok' }}
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Sipariş Güncelleme Tarihi:</p>
                                <p class="invoice-date" v-if="customer.order_last_update">
                                    {{ formatDate(customer.order_last_update) || 'Tarih Yok' }}
                                </p>
                                <p class="invoice-date" v-else>
                                    <span class="text-danger">Tarih Bulunmuyor.</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </b-card-body>
            </b-card>

            <!-- Aktif Paket Bilgisi -->
            <b-card title="Aktif Paket Bilgisi" v-if="packages === null || packages.length === 0">
                <div class="text-center">
                    <h5 class="text-muted">Henüz Paket Seçilmemiş</h5>
                    <p>Müşteri için bir paket seçin.</p>
                </div>
            </b-card>

            <!-- Aktif Paket Görüntüleme -->
            <b-card v-if="aktive_packages" title="Aktif Paket" class="mb-1">
                



                <!-- Paket Limitleri ve Kullanım -->
                <b-card-title>Paket Limitleri ve Kullanım</b-card-title>
                <package-limit-used :package="aktive_packages" :featuresLabel="featuresLabel"></package-limit-used>
                
            </b-card>


            <!-- Paket Geçmişi -->
            <b-card v-if="packages && packages.length > 0" title="Paket Geçmişi">
                
                <b-table
                    :items="packages"
                    :fields="packageHistoryFields"
                    responsive
                    class="mb-0"
                >
                    <template #cell(package_id)="data">
                        Paket {{ data.value }}
                    </template>
                    
                    <template #cell(date)="data">
                        {{ formatDate(data.value) }}
                    </template>

                    <template #cell(end_date)="data">
                        {{ formatDate(data.value) }}
                    </template>
                    
                    <template #cell(package_price)="data">
                        ₺{{ priceFormat(data.value) }}
                    </template>
                    
                    <template #cell(status)="data">
                        <b-badge :variant="data.value == 1 ? 'success' : 'secondary'">
                            {{ data.value == 1 ? 'Aktif' : 'Geçmiş' }}
                        </b-badge>
                    </template>

                    <template #cell(action)="data">
                        <b-button variant="warning" @click="seeDetailPackage(data.item)">
                            Kullanımları gör
                        </b-button>
                    </template>
                </b-table>
            </b-card>

            <plans 
                @update:plans="getCustomer"
                :plans="plans"
                :active_id="aktive_packages && aktive_packages.package_id ? aktive_packages.package_id : null"
                :customer_id="customer_id"
            ></plans>
            
        </div>
        <b-modal
         v-model="detailModal"
         size="xl"
         title="Paket Limitleri ve Kullanım"
         hide-footer
         >
            <package-limit-used :package="popupDetailPackage" :featuresLabel="featuresLabel"></package-limit-used>
        </b-modal>
    </div>
</template>


<script>
    import { BRow,
         BAlert,
          BBadge,
          BCardTitle,
           BCol, BCard,
            BCardHeader,
             BCardBody,
              BLink,
               BButton,
                BTable,
                 BTableSimple,
                  BThead, BTbody,
                   BTr,
                    BTd, BTh, BProgress, BModal} from 'bootstrap-vue';
    import LoadingCard from '@/layouts/components/isLoading.vue';
    import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
    import Plans from '../package/Plans.vue'
    import PackageLimitUsed from '@/components/package/PackageLimitUsed.vue';
    
    export default {
        components: {
            BRow,
            BCol,
            BCard,
            BCardHeader,
            BCardBody,
            BAlert,
            BBadge,
            BCardTitle,
            BLink,

            LoadingCard,
            BButton,
            BTable,
            BTableSimple,
            BThead,
            BTbody,
            BTr,
            BTd,
            BTh,
            BProgress,
            Plans,
            PackageLimitUsed,
            BModal
        },
        data() {
            return {
                isLoading : true,
                customer: null,
                customer_id:this.$route.params.id,
                aktive_packages:[],
                packages:[],
                featuresLabel:[],
                plans:[],
                packageHistoryFields: [
                    { key: 'package_name', label: 'Paket' },
                    { key: 'date', label: 'Başlangıç Tarihi' },
                    { key: 'end_date', label: 'Bitiş Tarihi' },
                    { key: 'package_price', label: 'Fiyat' },
                    { key: 'status', label: 'Durum' },
                    { key: 'action', label: 'Detay' }
                ],
                detailModal:false,
                popupDetailPackage:{}
            }
        },
        methods: {
            seeDetailPackage(packageDetail){
                this.detailModal=true;
                this.popupDetailPackage=packageDetail
            },
            

            async getPackageFeatures(){
                try {
                    const response = await this.$http.get('/manage/package-features');
                    if (response.data.success && response.data.data && response.data.data.length > 0) {
                        this.featuresLabel = {};
                        response.data.data.forEach(item => {
                            this.featuresLabel[item.feature_key] = {
                                name: item.feature_name,
                                type: item.type,
                                id: item.id
                            };
                        });
                    } 
                } catch (error) {
                    console.error('Paket içerik başlıkları alınırken alınırken hata:', error);
                }
            },
            async getCustomer() {
                try {
                    this.isLoading = true;
                    const response = await this.$http.get('/manage/customers', {
                        params: {
                            id: this.customer_id,
                            getadmin: true
                        }
                    });

                    if (response.data.data.Customers && response.data.data.Customers.length > 0) {
                        this.customer = response.data.data.Customers[0];
                        await this.getPackage();
                        await this.getPlans();
                        await this.getPackageFeatures();
                    } else {
                        console.warn('Müşteri bulunamadı');
                    }
                } catch (error) {
                    console.error('Müşteri bilgileri alınırken hata:', error);
                } finally {
                    this.isLoading = false;
                }
            },

            async getPackage() {
                try {
                    const response = await this.$http.get('/manage/get-package',{
                        params:{
                            id: this.customer_id,
                        }
                    });
                    if (response.data.success && response.data.data && response.data.data.length > 0) {
                        this.aktive_packages = response.data.data.find(item => item.status == 1);
                        this.packages = response.data.data;
                    } else {
                        this.aktive_packages = null;
                        this.packages = [];
                    }
                } catch (error) {
                    console.error('Paket bilgileri alınırken hata:', error);
                    this.aktive_packages = null;
                    this.packages = [];
                }
            },
            getPlans() {
                this.$http.get('/manage/packages').then(response => { 
                    this.plans = response.data.data
                })
            },      
            
        },
        mounted () {
            this.getCustomer();
        },
    }
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>